// @ts-check

// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const {
  useEmbeddedPlayerDisclosure
} = require('client-v2/common/contexts/embedded-player')
const tag = require('client-v2/common/utils/hyperscript')

const YOUTUBE_DOMAIN_REGEXP = /\b(youtube|youtu\.be)\b/

// BEM Block entity definition
const bem = BemEntity('EmbeddedPlayer')

/**
 * @param {Object} props
 * Values
 * @param {string} [props.className]
 * @param {string} props.src
 * Callbacks
 * @param {() => void} props.onDisclose
 * @param {() => void} props.onUndisclose
 * @returns {React.ReactElement}
 */
function EmbeddedPlayer({
  // Values
  className,
  src,
  // Callbacks
  onDisclose,
  onUndisclose
}) {
  const isYoutubeSrc = React.useMemo(
    () => YOUTUBE_DOMAIN_REGEXP.test(src),
    [ YOUTUBE_DOMAIN_REGEXP, src ]
  )
  const [ isDisclosed, onClick ] =
    useEmbeddedPlayerDisclosure({ onDisclose, onUndisclose })
  if (!isDisclosed) {
    return (
      tag('div', {
        className: classNames(
          className,
          bem.block({
            curtain: true,
            youtube: isYoutubeSrc
          })
        ),
        onClick
      })
    )
  }
  return (
    tag('iframe', {
      className: classNames(
        className,
        bem.block({
          disclosed: true,
          youtube: isYoutubeSrc
        })
      ),
      src,
      allowFullScreen: true,
      frameBorder: '0',
      height: '100%',
      width: '100%'
    })
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  EmbeddedPlayer.propTypes = {
    // Values
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    // Callbacks
    onDisclose: PropTypes.func
  }
}

module.exports = EmbeddedPlayer
